export default "__VITE_ASSET__80df024f__"